import React from 'react';
import Reveal from 'react-awesome-reveal';
import Image from 'next/image';
// Import Settigns
import { fadeInRightShorter } from '../../../utils/data/keyframes';
import { useDispatch, useSelector } from 'react-redux';
import { setCategory } from '../../../store/categories';
import { useRouter } from 'next/router';
import { sections } from '../../../utils/data/shop';

// Stubbed pictures template
const pictures = {
  1: '/images/category/bed_cat_pict2.svg',
  2: '/images/category/din_cat_pict.svg',
  3: '/images/category/prim_cat_pict.svg',
  4: '/images/category/off_cat_pict.svg',
  5: '/images/category/fitness_Fun.svg',
  6: '/images/category/patio_Outdoor.svg',
  7: '/images/category/home_Decor.svg',
  8: ''
};

function BannerSection() {
  const categories = useSelector(state => state.categories.categories);
  const dispatch = useDispatch();
  const router = useRouter();
  const query = router.query;

  return (
    <div className="container banner-container">
      <div>
        <h3 className="subtitle banner-subtitle">Categories</h3>
        <div className="heading-spacer" />
      </div>

      <div className={'row d-flex justify-content-center'}>
        <div className={'wrapper'}>
          {categories.map((category, index) => {
            if (category.name?.toUpperCase() === 'HOT SALE') return;

            return (
              <div onClick={() => {
                dispatch(setCategory(category));
                router.push({
                  pathname: '/shop',
                  query: {
                    ...query,
                    filters: JSON.stringify({
                      [sections.categories]: [category.name],
                      [sections.price]: { min: 0, max: 0 },
                      [sections.materials]: [],
                      [sections.colors]: []
                    })
                  }
                });
              }} className={`box${index + 1}`} key={category?.name + index}>
                <span className={'cat-title font2'}>{category.name}</span>
                <Reveal
                  delay={200}
                  duration={1000}
                  keyframes={fadeInRightShorter}
                  triggerOnce>
                  <div
                    className="banner-image">
                    <figure className={'figure-margin'}>
                      <Image
                        alt="banner"
                        height={262}
                        src={pictures[category.category_id]}
                        width={262}
                      />
                    </figure>
                  </div>
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default React.memo(BannerSection);
